export default {
  "pl": {
    "installment_term": {
      "actions": {
        "addUnits": "Dodaj jednostki",
        "create": "Utwórz",
        "create_price_term": "Nowa zasada",
        "delete": "Usuń",
        "deleteMultiple": "Usuń…",
        "delete_cancel": "Anuluj",
        "edit": "Edytuj",
        "newInstallment": "Dodaj warunek dotyczący rat",
        "selectAll": "Wybierz wszystkie liczba rat ({total})",
        "selectOne": "Wybierz przynajmniej 1 rata",
        "take": "Weź"
      },
      "attributes": {
        "description": "Opis",
        "installments_count": "{count} rata | Liczba rat: {count}",
        "name": "Tytuł"
      },
      "labels": {
        "addAllSurcharges": "Dodaj wszystkie aktualne dopłaty",
        "addAllUnitsPrices": "Dodaj wszystkie ceny jednostkowe",
        "allUnitsAssigned": "Wszystkie przypisane jednostki",
        "amount": "Wartość raty",
        "balanceFractionTypes": "Rodzaje rat",
        "balanceTotal": "Całkowity rachunek",
        "containsSurcharges": "Z opłatami dodatkowymi",
        "deleteInstallmentTerm": "Usuń warunek dotyczący rat",
        "editInstallmentTerm": "Edytuj warunek dotyczący rat",
        "fixed": "Opłata stała",
        "fixedAmount": "Stała kwota:",
        "forEachUnit": "każdej jednostki",
        "fraction_types": {
          "absolute": "Stała kwota",
          "relative": "Procent"
        },
        "goToAmounts": "Wartości rat",
        "installments": "Dane finansowe",
        "installmentsTitle": "Rata",
        "invalidAmount": "Niepoprawna kwota",
        "name": "{count}. warunek dotyczący rat",
        "noContainsSurcharges": "Bez opłat dodatkowych",
        "noInstallmentsToPay": "Brak rat do zapłaty",
        "noUnitsClick": "Brak jednostek – kliknij tutaj, aby dodać",
        "ofThe": "z:",
        "price_types": {
          "price_value": "Łączna wartość",
          "price_value_construction": "Wartość inwestycji",
          "price_value_construction_existing": "Koszt istniejącej inwestycji",
          "price_value_fees": "Opłaty dla architektów/inżynierów",
          "price_value_land": "Wartość gruntu",
          "surcharge": "Opłaty dodatkowe",
          "unit": "Ceny jednostek"
        },
        "projectUnitsTotal": "{project_name} ma łącznie {units_count_max} jednostek",
        "selectUnits": "Wybierz jednostki",
        "selected": "Wybrano {selected} rata. | Wybrano następującą liczbę rat: {selected}.",
        "shortcuts": "Shortcuts",
        "step1Info": "Dodaj opis",
        "step2Subtitle": "Wybierz swój projekt, aby uwzględnić wszystkie jednostki naraz.",
        "step2Title": "Jakie jednostki są związane z tą ratą?",
        "surcharges": "Opłaty dodatkowe",
        "total": "Łącznie",
        "totalFixed": "Łączna opłata stała",
        "totalPaid": "Łącznie zapłacono",
        "totalRequested": "Łącznie do zapłaty",
        "totalSelected": "Wybrano wszystkie liczba rat ({total}).",
        "totalSurcharges": "Suma opłat dodatkowych",
        "totalUnpaid": "Pozostało do zapłaty",
        "unitSelected": "Brak jednostek | 1 jednostka | Liczba jednostek: {count}",
        "units": "Jednostki"
      },
      "navigation": {
        "backToInstallmentTerms": "Wróć do przeglądu warunków dotyczących rat"
      },
      "placeholders": {
        "amount": "Określ opłatę stałą lub podaj procent wartości jednostki",
        "description": "Np. 10% – po wybetonowaniu pierwszego piętra…",
        "due_date": "Wyznacz termin płatności raty",
        "employees": {
          "new": {
            "subtitle": "Dodaj raty i śledź ich status",
            "title": "Utwórz przegląd finansowy"
          }
        },
        "installmentTermFractionNotice": "Kwoty rat nie mogą być już korygowane, ponieważ niektóre raty zostały już dostarczone kupującemu",
        "name": "Np. 1. warunek dotyczący rat, warunek dotyczący rat – opłaty dodatkowe",
        "summary": "Podsumowanie",
        "surcharge": "opłata dodatkowe"
      },
      "toasts": {
        "bulk_create": "Rata została utworzona | Raty zostały utworzone",
        "bulk_delete": "Rata została usunięta | Raty zostały usunięte",
        "bulk_update": "Rata została zaktualizowana | Raty zostały zaktualizowane",
        "delete": "Rata została usunięta",
        "update": "Rata została zaktualizowana"
      },
      "validation": {
        "fixedFractionLabel": "{price_type} został już połączony z {fraction_type} w innej istniejącej racie. Tylko {fraction_type} może zachować spójność.",
        "maxLengthName": "Nazwa jest zbyt długa",
        "needDescription": "Należy dodać opis",
        "needInstallmentTermFraction": "Należy podać przynajmniej jedną cenę dla danego warunku",
        "needName": "Należy podać nazwę",
        "needUniquePricesTypes": "Regulamin nie może mieć tej samej ceny w jednej racie",
        "needValidTerm": "Należy podać kwotę większą niż 0 i upewnić się, że dana podstawa raty istnieje",
        "selectInstallmentTerm": "Wybierz przynajmniej 1 ratę",
        "selectUnit": "Wybierz przynajmniej 1 jednostkę"
      }
    }
  }
}
